import Skills from "./Skills"

const RecursiveComponent = (props) => {
    return (
        <>
        {props.data.map((item, index) => {
           return (
            <>
                <li index={index}> {item.content} {item.progress ? <progress value={item.progress} max={100}> </progress> :"" } </li>
                {item.children.length > 0 && <ol><RecursiveComponent data={item.children} /></ol>}
            </>
           )
        
        })}
        </>
    )
}

const CardItem = (props) => {
    return (
        <div className={`container d-flex flex-row-${props.position === 'left'? '' : 'reverse'} position-relative`}>
            <div className='col-12 col-lg-6 my-5 d-flex justify-content-center align-items-center'>
                <div className='card-item-img d-flex justify-content-center align-items-center '>
                    <img className='' src={props.img} alt='' />
                </div> 
                <div className='card-item-content px-4 py-3'>
                    <h2 className='text-center'>{props.title}</h2>
                    <div className='mt-4'> 
                       {
                        props.items.length ? <ol>
                        <RecursiveComponent data={props.items} /> </ol> : <Skills skills = {props.skills} />
                       }
                    </div>
                </div>
            </div>

        </div>
    )
}

export default CardItem
